import classNames from 'classnames'
import React, { ComponentType, ReactNode, useContext } from 'react'

import { IconProps } from '../../icon/icon.js'
import { ListContext } from './list.js'

export interface ListItemProps {
    children: ReactNode
    className?: string
    icon?: ComponentType<IconProps>
    iconClassName?: string
}

export const ListItem = (props: ListItemProps): JSX.Element => {
    const context = useContext(ListContext)

    const className: string = classNames('list__item', props.className)

    const renderIcon = (icon: ComponentType<IconProps>) => {
        const Icon = icon

        const iconClasses: string = classNames(
            'list__icon',
            !(context.iconClassName || props.iconClassName) && 'list__icon--default',
            context.iconClassName,
            props.iconClassName,
        )

        return <Icon className={iconClasses} />
    }

    const icon = props.icon || context.icon

    return (
        <li className={className}>
            <div className="list__item-inner">
                {icon && renderIcon(icon)}
                <div className="list__content">{props.children}</div>
            </div>
        </li>
    )
}
